import PhoneScrean from "../../Components/Auth/LogedInScrean";
import { IconsLoader } from "../../imports/icon";
import { useSelector } from "react-redux";
import React, { useState } from "react";
import one from "../../assets/images/damalogin.jpg";
import heroMobile from "../../assets/mobileGroup.png";

import Profile from "../../Components/Auth/Profile";
import { Card } from "antd";
import { Link } from "react-router-dom";
import LoginCard from "../../Components/Auth/LoginCard";
import HeroImage from "../../Components/Auth/HeroImage";
import SubscribeCard from "../../Components/Auth/SubscribeCard";
import TestProfile from "./TestProfile";

export default function Personalized() {
  const isLogedIn = useSelector((state) => state.user.isLogedIn);

  if (isLogedIn) {
    return <TestProfile />;
    // return <Profile />;
  } else {
    return (
      <div className=" relative pt-36 sm:pt-0  bg-light-green w-full sm:flex sm:justify-end  sm:items-center  h-screen">
        <img
          src={heroMobile}
          alt="mobilehero"
          className=" object-cover w-full  sm:hidden absolute top-0 left-0"
        />

        <div className=" px-4 sm:hidden relative z-10 h-[80%] flex items-center justify-center w-full ">
          <LoginCard />
        </div>

        {/* desktop screen */}
        <HeroImage />
        <div className=" hidden flex-[1]  h-full  sm:flex  justify-center lg:justify-normal   pt-8">
          <LoginCard />
        </div>
      </div>
      // <div
      //   className="flex max-h-[90vh] md:min-h-[93.3vh] min-h-[90vh]   !w-[100vw] md:w-[100%] bg-[#242C37] bg-repeat-x"
      //   style={{
      //     backgroundImage: `url(${one})`,
      //     backgroundSize: "cover",
      //     // backgroundRepeat: "no-repeat",
      //   }}
      // >
      //   <div className="right-0 md:visible invisible absolute z-0 w-[60%]"></div>
      //   <div className="md:w-[40%] max-h-[100vh] w-[100%] px-5 md:px-12  bg-[#242C37] flex flex-col justify-center  ">
      //     <div className="px-5">
      //       {/* <IconsLoader icon="logosimple" className={"w-[50px] xl:w-[10vh]"}  height={60} /> */}
      //     </div>
      //     <PhoneScrean />
      //   </div>
      // </div>
    );
  }
}
